import { render } from "./ProjectsTable.vue?vue&type=template&id=32fe596f"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\2023\\Documents\\GitHub\\POS-APP-FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__